import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoMoereOgRomsdalPrimaerBokmaalNegativPdf,
  LogoMoereOgRomsdalPrimaerBokmaalNegativPng,
  LogoMoereOgRomsdalPrimaerBokmaalNegativSvg,
  LogoMoereOgRomsdalPrimaerBokmaalPositivPdf,
  LogoMoereOgRomsdalPrimaerBokmaalPositivPng,
  LogoMoereOgRomsdalPrimaerBokmaalPositivSvg,
  LogoMoereOgRomsdalPrimaerBokmaalEngelskNegativPdf,
  LogoMoereOgRomsdalPrimaerBokmaalEngelskNegativPng,
  LogoMoereOgRomsdalPrimaerBokmaalEngelskNegativSvg,
  LogoMoereOgRomsdalPrimaerBokmaalEngelskPositivPdf,
  LogoMoereOgRomsdalPrimaerBokmaalEngelskPositivPng,
  LogoMoereOgRomsdalPrimaerBokmaalEngelskPositivSvg,
  LogoMoereOgRomsdalPrimaerNynorskNegativPdf,
  LogoMoereOgRomsdalPrimaerNynorskNegativPng,
  LogoMoereOgRomsdalPrimaerNynorskNegativSvg,
  LogoMoereOgRomsdalPrimaerNynorskPositivPdf,
  LogoMoereOgRomsdalPrimaerNynorskPositivPng,
  LogoMoereOgRomsdalPrimaerNynorskPositivSvg,
  LogoMoereOgRomsdalPrimaerNynorskEngelskNegativPdf,
  LogoMoereOgRomsdalPrimaerNynorskEngelskNegativPng,
  LogoMoereOgRomsdalPrimaerNynorskEngelskNegativSvg,
  LogoMoereOgRomsdalPrimaerNynorskEngelskPositivPdf,
  LogoMoereOgRomsdalPrimaerNynorskEngelskPositivPng,
  LogoMoereOgRomsdalPrimaerNynorskEngelskPositivSvg,
  LogoMoereOgRomsdalSekundaerBokmaalNegativPdf,
  LogoMoereOgRomsdalSekundaerBokmaalNegativPng,
  LogoMoereOgRomsdalSekundaerBokmaalNegativSvg,
  LogoMoereOgRomsdalSekundaerBokmaalPositivPdf,
  LogoMoereOgRomsdalSekundaerBokmaalPositivPng,
  LogoMoereOgRomsdalSekundaerBokmaalPositivSvg,
  LogoMoereOgRomsdalSekundaerBokmaalEngelskNegativPdf,
  LogoMoereOgRomsdalSekundaerBokmaalEngelskNegativPng,
  LogoMoereOgRomsdalSekundaerBokmaalEngelskNegativSvg,
  LogoMoereOgRomsdalSekundaerBokmaalEngelskPositivPdf,
  LogoMoereOgRomsdalSekundaerBokmaalEngelskPositivPng,
  LogoMoereOgRomsdalSekundaerBokmaalEngelskPositivSvg,
  LogoMoereOgRomsdalSekundaerNynorskNegativPdf,
  LogoMoereOgRomsdalSekundaerNynorskNegativPng,
  LogoMoereOgRomsdalSekundaerNynorskNegativSvg,
  LogoMoereOgRomsdalSekundaerNynorskPositivPdf,
  LogoMoereOgRomsdalSekundaerNynorskPositivPng,
  LogoMoereOgRomsdalSekundaerNynorskPositivSvg,
  LogoMoereOgRomsdalSekundaerNynorskEngelskNegativPdf,
  LogoMoereOgRomsdalSekundaerNynorskEngelskNegativPng,
  LogoMoereOgRomsdalSekundaerNynorskEngelskNegativSvg,
  LogoMoereOgRomsdalSekundaerNynorskEngelskPositivPdf,
  LogoMoereOgRomsdalSekundaerNynorskEngelskPositivPng,
  LogoMoereOgRomsdalSekundaerNynorskEngelskPositivSvg,
  LogoMoereOgRomsdalSentrertBokmaalNegativPdf,
  LogoMoereOgRomsdalSentrertBokmaalNegativPng,
  LogoMoereOgRomsdalSentrertBokmaalNegativSvg,
  LogoMoereOgRomsdalSentrertBokmaalPositivPdf,
  LogoMoereOgRomsdalSentrertBokmaalPositivPng,
  LogoMoereOgRomsdalSentrertBokmaalPositivSvg,
  LogoMoereOgRomsdalSentrertBokmaalEngelskNegativPdf,
  LogoMoereOgRomsdalSentrertBokmaalEngelskNegativPng,
  LogoMoereOgRomsdalSentrertBokmaalEngelskNegativSvg,
  LogoMoereOgRomsdalSentrertBokmaalEngelskPositivPdf,
  LogoMoereOgRomsdalSentrertBokmaalEngelskPositivPng,
  LogoMoereOgRomsdalSentrertBokmaalEngelskPositivSvg,
  LogoMoereOgRomsdalSentrertNynorskNegativPdf,
  LogoMoereOgRomsdalSentrertNynorskNegativPng,
  LogoMoereOgRomsdalSentrertNynorskNegativSvg,
  LogoMoereOgRomsdalSentrertNynorskPositivPdf,
  LogoMoereOgRomsdalSentrertNynorskPositivPng,
  LogoMoereOgRomsdalSentrertNynorskPositivSvg,
  LogoMoereOgRomsdalSentrertNynorskEngelskNegativPdf,
  LogoMoereOgRomsdalSentrertNynorskEngelskNegativPng,
  LogoMoereOgRomsdalSentrertNynorskEngelskNegativSvg,
  LogoMoereOgRomsdalSentrertNynorskEngelskPositivPdf,
  LogoMoereOgRomsdalSentrertNynorskEngelskPositivPng,
  LogoMoereOgRomsdalSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Moere-og-Romsdal/exportMoereOgRomsdal.js";

export default function MøreOgRomsdalPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Møre og Romsdal"
          lead="Alle logoer for Møre og Romsdal i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Møre og Romsdal, bokmål"
                    text="Bokmål"
                    blackSvg={LogoMoereOgRomsdalPrimaerBokmaalPositivSvg}
                    blackPng={LogoMoereOgRomsdalPrimaerBokmaalPositivPng}
                    blackPdf={LogoMoereOgRomsdalPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalPrimaerBokmaalNegativSvg}
                    whitePng={LogoMoereOgRomsdalPrimaerBokmaalNegativPng}
                    whitePdf={LogoMoereOgRomsdalPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Møre og Romsdal, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoMoereOgRomsdalPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoMoereOgRomsdalPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoMoereOgRomsdalPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoMoereOgRomsdalPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoMoereOgRomsdalPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Møre og Romsdal, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoMoereOgRomsdalPrimaerNynorskPositivSvg}
                    blackPng={LogoMoereOgRomsdalPrimaerNynorskPositivPng}
                    blackPdf={LogoMoereOgRomsdalPrimaerNynorskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalPrimaerNynorskNegativSvg}
                    whitePng={LogoMoereOgRomsdalPrimaerNynorskNegativPng}
                    whitePdf={LogoMoereOgRomsdalPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Møre og Romsdal, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoMoereOgRomsdalPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoMoereOgRomsdalPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoMoereOgRomsdalPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoMoereOgRomsdalPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoMoereOgRomsdalPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalSekundaerBokmaalPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Møre og Romsdal, bokmål"
                    text="Bokmål"
                    blackSvg={LogoMoereOgRomsdalSekundaerBokmaalPositivSvg}
                    blackPng={LogoMoereOgRomsdalSekundaerBokmaalPositivPng}
                    blackPdf={LogoMoereOgRomsdalSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalSekundaerBokmaalNegativSvg}
                    whitePng={LogoMoereOgRomsdalSekundaerBokmaalNegativPng}
                    whitePdf={LogoMoereOgRomsdalSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalSekundaerBokmaalEngelskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Møre og Romsdal, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoMoereOgRomsdalSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoMoereOgRomsdalSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoMoereOgRomsdalSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoMoereOgRomsdalSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoMoereOgRomsdalSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalSekundaerNynorskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Møre og Romsdal, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoMoereOgRomsdalSekundaerNynorskPositivSvg}
                    blackPng={LogoMoereOgRomsdalSekundaerNynorskPositivPng}
                    blackPdf={LogoMoereOgRomsdalSekundaerNynorskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalSekundaerNynorskNegativSvg}
                    whitePng={LogoMoereOgRomsdalSekundaerNynorskNegativPng}
                    whitePdf={LogoMoereOgRomsdalSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalSekundaerNynorskEngelskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Møre og Romsdal, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoMoereOgRomsdalSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoMoereOgRomsdalSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoMoereOgRomsdalSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoMoereOgRomsdalSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoMoereOgRomsdalSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalSentrertBokmaalPositivSvg}
                    title="Sentert logo: Statsforvalteren i Møre og Romsdal, bokmål"
                    text="Bokmål"
                    blackSvg={LogoMoereOgRomsdalSentrertBokmaalPositivSvg}
                    blackPng={LogoMoereOgRomsdalSentrertBokmaalPositivPng}
                    blackPdf={LogoMoereOgRomsdalSentrertBokmaalPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalSentrertBokmaalNegativSvg}
                    whitePng={LogoMoereOgRomsdalSentrertBokmaalNegativPng}
                    whitePdf={LogoMoereOgRomsdalSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalSentrertBokmaalEngelskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Møre og Romsdal, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoMoereOgRomsdalSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoMoereOgRomsdalSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoMoereOgRomsdalSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoMoereOgRomsdalSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoMoereOgRomsdalSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalSentrertNynorskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Møre og Romsdal, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoMoereOgRomsdalSentrertNynorskPositivSvg}
                    blackPng={LogoMoereOgRomsdalSentrertNynorskPositivPng}
                    blackPdf={LogoMoereOgRomsdalSentrertNynorskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalSentrertNynorskNegativSvg}
                    whitePng={LogoMoereOgRomsdalSentrertNynorskNegativPng}
                    whitePdf={LogoMoereOgRomsdalSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoMoereOgRomsdalSentrertNynorskEngelskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Møre og Romsdal, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoMoereOgRomsdalSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoMoereOgRomsdalSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoMoereOgRomsdalSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoMoereOgRomsdalSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoMoereOgRomsdalSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoMoereOgRomsdalSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
